import type { InterviewResult } from '@core/interview-results-types';
import type { Placement } from '@core/placements-types';

export const ratingMap: { [key: string]: number } = {
  strong_no: 0,
  no: 0,
  neutral: 0.5,
  yes: 0.75,
  strong_yes: 1,
};

export const calculateRating = (group: InterviewResult[]) => {
  const interviewResultsWithRating = group.filter(result => result.rating);

  if (interviewResultsWithRating.length === 0) {
    return null;
  }

  const ratingSum = interviewResultsWithRating.reduce((overallRating, result) => {
    const resultRating = ratingMap[result.rating] || 0;

    return overallRating + resultRating;
  }, 0);

  return Math.round((ratingSum / interviewResultsWithRating.length) * 100);
};

export const isPlacementRatingVisible = (
  placements: Placement[],
  offerId?: number | null,
): boolean => {
  if (offerId === undefined || offerId === null) {
    return true;
  }

  return !!placements.find(
    (placement: Placement) => placement.offerId === offerId && placement.ratingVisible,
  );
};
